"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var Info_14px_small_1 = require("../../img/Info_14px_small");
var TriangleDown_1 = require("../../img/model-results/TriangleDown");
var TriangleUp_1 = require("../../img/model-results/TriangleUp");
var LayoutStyles_1 = require("../../styles/LayoutStyles");
var CardHeader = function (_a) {
    var header = _a.header, tooltip = _a.tooltip;
    var getTooltipInfo = function () { return React.createElement("span", null, tooltip); };
    return (React.createElement("div", { className: LayoutStyles_1.CardHeaderStyle },
        header,
        "\u00A0",
        tooltip && (React.createElement(widgets_1.Tooltip, { getContent: getTooltipInfo },
            React.createElement("span", null, React.createElement(Info_14px_small_1.InfoSmall, null))))));
};
var CardContainer = function (_a) {
    var children = _a.children, header = _a.header, description = _a.description, tooltip = _a.tooltip, width = _a.width, style = _a.style;
    return (React.createElement("div", { className: LayoutStyles_1.CardContainerStyle, style: __assign({ width: width }, style) },
        React.createElement(CardHeader, { header: header, tooltip: tooltip }),
        description && React.createElement("div", { className: LayoutStyles_1.CardDescriptionStyle }, description),
        children));
};
var CardsList = function (_a) {
    var children = _a.children, icon = _a.icon, title = _a.title, description = _a.description, _b = _a.indent, indent = _b === void 0 ? true : _b, _c = _a.borderTop, borderTop = _c === void 0 ? true : _c, _d = _a.expand, expand = _d === void 0 ? false : _d;
    var cardContentCss = [LayoutStyles_1.CardListContentStyle];
    indent && cardContentCss.push(LayoutStyles_1.CardListContentIndent);
    var cardListCss = [LayoutStyles_1.CardListStyle];
    borderTop && cardListCss.push(LayoutStyles_1.CardListBorder);
    var _e = React.useState(true), expanded = _e[0], setExpanded = _e[1];
    var expandElement;
    if (expand) {
        var onExpanded = function () {
            setExpanded(!expanded);
        };
        expandElement = (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, onClick: onExpanded, className: LayoutStyles_1.CardListExpand }, expanded ? (React.createElement(React.Fragment, null,
            React.createElement(TriangleUp_1.TriangleUp, null),
            " ",
            Localize_1.Messages.cardCollapse())) : (React.createElement(React.Fragment, null,
            React.createElement(TriangleDown_1.TriangleDown, null),
            " ",
            Localize_1.Messages.cardExpand()))));
    }
    if (!expanded) {
        cardContentCss.push(LayoutStyles_1.CardListContentHiddenStyle);
    }
    var renderHeader = function () {
        if (!icon && !title && !description) {
            return null;
        }
        return (React.createElement("div", { className: LayoutStyles_1.CardListHeader },
            React.createElement("div", { className: LayoutStyles_1.CardListHeaderIcon }, icon),
            React.createElement("div", { className: LayoutStyles_1.CardListHeaderContent },
                React.createElement("div", { className: LayoutStyles_1.CardListHeaderContentH1 }, title),
                React.createElement("div", { className: LayoutStyles_1.CardListHeaderContentH3 }, description)),
            expandElement));
    };
    return (React.createElement("div", { className: cardListCss.join(' ') },
        renderHeader(),
        React.createElement("div", { className: cardContentCss.join(' ') }, children)));
};
var Card = function (_a) {
    var children = _a.children, hideBorder = _a.hideBorder, styles = _a.styles;
    var cssClass = "".concat(LayoutStyles_1.CardGeneralStyle, " ").concat(hideBorder ? '' : LayoutStyles_1.CardBorderStyle);
    return (React.createElement("div", { className: cssClass, style: styles }, children));
};
exports.Card = Card;
exports.Card.Container = CardContainer;
exports.Card.List = CardsList;
//# sourceMappingURL=Card.js.map